export const ACCEPT_ATTR = ".jpg,.jpeg,.png,image/jpeg,image/png";

export const validateImageFile = (file) => {
  const ext = file.name?.split(".").pop()?.toLowerCase();
  const typeOk = ["image/jpeg", "image/jpg", "image/png"].includes(file.type);
  const extOk = ["jpg", "jpeg", "png"].includes(ext);
  return typeOk && extOk ? "" : "Only JPG, JPEG or PNG images are allowed";
};

// DD-MM-YYYY / DD/MM/YYYY / YYYY-MM-DD → YYYY-MM-DD
export const parseDobToInputFormat = (raw) => {
  if (!raw) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(raw)) {
    const [day, month, year] = raw.split(/[-/]/);
    return `${year}-${month}-${day}`;
  }
  return "";
};

export const validateDetails = ({ dob, address }) => {
  const errors = {};
  if (!dob) errors.dob = "Please enter a valid date of birth.";
  if (!address || address.trim().length < 5)
    errors.address = "Address must be at least 5 characters long.";
  return errors;
};

export const inputClass = (hasError) =>
  `w-full px-3 py-2 border-2 rounded-lg text-sm ${
    hasError
      ? "border-red-300 bg-red-50 focus:ring-red-200 focus:border-red-500"
      : "border-gray-200 hover:border-indigo-300 focus:ring-indigo-100 focus:border-indigo-500"
  }`;